import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import {MatChipInputEvent} from '@angular/material/chips';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import {MatSliderModule} from '@angular/material/slider';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class InvoicesComponent implements OnInit {

  DocumentBodyLoading:boolean;
  loading:boolean;
  ShowCashCollectionContainer:boolean;
  AllSelected:boolean;

  loadingDocumentInformation:boolean;
  loadingInvoiceID:string;

  Invoices:any[];
  Filter: {[k: string]: any} = {};
  Totals: any[];

  showFilter:boolean;
  partner:any;
  currentPartner:any;
  currentCashCollettion: {[k: string]: any} = {};


  EFacturaStatuses:any[];
  Currencies:any[];
  DocTypes:any[];
  DecimalPrecisions:any[];
  AccountingSeries:any[];
  Administrations:any[];
  MeasuringUnits:any[];
  VATRates:any[];
  ProductGeneralTypes:any[];
  DocumentStatuses:any[];
  Periods:any[];
  Languages:any[];
  PaymentTerms:any[];
  DiscountTypes:any[];
  Agents:any[];
  Countries:any[];
  CashCollectTypes:any[];
  CashCollections:any[];
  ShowSuggestionCashCollectionsContainer:boolean;
  CashTotals:any[];
  SortingOrders:any[];
  CountryFilterOptions:any[];
  PartnerTypes:any[];
  TranzactionTypes:any[];
  InvoiceModels:any[];

  BankAccounts:any[];

  showEditPartnerPopUp:boolean;
  ExportAllOrPageOnlyQuestion:boolean;

  InvoicePrecision:any;

  currency:any;
  newPartnerCountry:any;
  newPartnerBank:any;
  newPartner:any;

  searchTerm:string;
  resultsLength = 0;
  pageSize = 999999;

  Partners:any[];
  countryID:number;
  activeFilters:{[k: string]: any} = [];

  Products:any[];
  CurrentInvoice: {[k: string]: any} = {};

  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());
  CollectionDate = new FormControl(moment());

  showInvoiceVisualizer:boolean;
  IsCollectiveCollection:boolean;
  CollectionRemainingValue:any;

  ShippingWays:any[];
  ShippingServiceTypes:any[];
  ShippingResponsabilities:any[];
  ShippingCompanies:any[];
  WeightTypes:any[];
  ShippingMasterData:any;

  ShowForceStatusContainer:boolean;

  searchPartnerUpdate = new Subject<string>();

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) { 

    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

     // Debounce search.
     this.searchPartnerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetPartnersFiltered(value, this.countryID, true);
      });
  }

  ngOnInit(): void {
    this.showFilter = false;
    this.DocumentBodyLoading = false;
    this.InitializeFilter();
    this.GetInvoiceMasterData();
    this.GetInvoicesFiltered();
    this.countryID = null;
    this.IsCollectiveCollection = false;

    this.GetShippingMasterData();
  }

  GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:this.pageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if(this.searchTerm.length >= 3){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];

         if(this.Partners.length == 1){
          this.partner = this.Partners[0]; this.resultsLength = 0; this.searchTerm = this.Partners[0].Name; this.Filter.Partner = this.Partners[0]; this.AddActiveFilter(this.Partners[0].Name, 'Partner');
          this.GetInvoicesFiltered(1);
         }
        }
     
        this.parent.loading = false;
      });
    }
  }

  InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:10,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];
        }
     
        this.parent.loading = false;
      });
    }
    else{
      this.Partners = [];
      this.resultsLength = 0;
    }
  }

  GetInvoiceMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetInvoiceMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Currencies = response["Currencies"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
        this.AccountingSeries = response["AccountingSeries"];
        this.Languages = response["Languages"];
        this.PaymentTerms = response["PaymentTerms"];
        this.Administrations = response["Administrations"];
        this.MeasuringUnits = response["MeasuringUnits"];
        this.VATRates = response["VATRates"];
        this.ProductGeneralTypes = response["ProductGeneralTypes"];
        this.DiscountTypes = response["DiscountTypes"];
        this.Agents = response["Agents"];
        this.DocTypes = response["DocTypes"];
        this.Periods = response["Periods"];
        this.DocumentStatuses = response["DocumentStatuses"];
        this.Countries = response["Countries"];
        this.CashCollectTypes = response["CashCollectTypes"];
        this.currentCashCollettion.Type = this.CashCollectTypes[1];
        this.BankAccounts = response["BankAccounts"];
        this.SortingOrders = response["SortingOrders"];
        this.CountryFilterOptions = response["CountryFilterOptions"];
        this.PartnerTypes = response["PartnerTypes"];
        this.TranzactionTypes = response["TranzactionTypes"];
        this.InvoiceModels = response["InvoiceModels"];
        this.EFacturaStatuses = response["EFacturaStatuses"];

        this.currency = this.Currencies[0];
        this.InvoicePrecision = this.DecimalPrecisions[0];

        this.Filter.SortingOrder = this.SortingOrders[0];
      }
   
      this.parent.loading = false;
    });
  }

  InitializeFilter(){

    this.Filter = {};
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;
    this.Filter.Administration = {};
    this.Filter.AccountingSeries = {};
    this.Filter.Product = "";
    this.Filter.Partner = {};
    this.Filter.DocumentNumber = "";
    this.Filter.DocumentStatus = {};
    this.Filter.Period = {};
    this.Filter.Period = null;
    this.Filter.Country = {};
    this.Filter.Country = null;
    this.Filter.Currency = {};
    this.Filter.Currency = null;

    this.Filter.SortingOrder = {};
    this.Filter.SortingOrder = null;

    this.Filter.InvoiceDocType = {};
    this.Filter.InvoiceDocType = null;

    this.Filter.CountryFilterOption = {};
    this.Filter.CountryFilterOption = null;

    this.Filter.PartnerType = {};
    this.Filter.PartnerType = null;

    this.Filter.TranzactionType = {};
    this.Filter.TranzactionType = null;

    this.Filter.ShippingCompany = {};
    this.Filter.ShippingCompany = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;
    this.Filter.ExchangeToTargetCurrency = false;
  }

  GetInvoicesFiltered(page = 1){

    this.Filter.Pager.PageIndex = page;

    if(this.Filter.DisplayAllPagesTotals == true){
      this.Filter.ExchangeToTargetCurrency = false;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }
    
    this.loading = true;
    this.showFilter = false;

    this.service.GetGalleryInvoices(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Invoices = response["Invoices"];
        this.Totals = response["Totals"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
        this.GetGalleryInvoicesAfterInfo();
      }
      
      this.AllSelected = false;
      this.loading = false;
    });

    this.GetInvoicesFilteredCOUNT();
  }

  GetGalleryInvoicesAfterInfo(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter,
      Invoices:this.Invoices
    };

    this.service.GetGalleryInvoicesAfterInfo(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Invoices = response["Invoices"];
      }
   
    });
  }

  GetInvoicesFilteredCOUNT(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }

    this.service.GetInvoicesFilteredCOUNT(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
   
    });
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  GetPartnerEUData(partner:any, addnew:boolean){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      VAT:partner.value.VAT,
      CountryCode:partner.value.Country.ShortName
    };

    this.parent.loading = true;

    this.service.GetPartnerEUData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1 && response["EUVATVerified"] == true){

        if(addnew){

          this.newPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(''),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(''),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(''),
            City:new FormControl(''),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
        
            Bank:new FormControl(''),
            BankAccount:new FormControl(''),
        
            Email: new FormControl('', [Validators.email]),
            ContactName:new FormControl(''),
            Phone:new FormControl(''),
          });
        }
        else{

          this.currentPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(this.partner.UPN),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(this.partner.COCRegNumber),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(this.partner.BillingAddress.StateProvince, [Validators.required]),
            City:new FormControl(this.partner.BillingAddress.City, [Validators.required]),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
        
            Bank:new FormControl(this.partner.Bank),
            BankAccount:new FormControl(this.partner.Bank.BankAccount),
        
            Email: new FormControl(this.partner.ContactInfo.Email, [Validators.email]),
            ContactName:new FormControl(this.partner.ContactInfo.Name),
            Phone:new FormControl(this.partner.ContactInfo.Phone),
          });

          this.partner.EUVATVerified = response["EUVATVerified"];
        }
      }
   
      this.parent.loading = false;
    });
  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };
    
    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.showFilter = false;
      this.GetInvoicesFiltered();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Administration"){
      this.Filter.Administration = null;
    }
    else if(filterType == "Series"){
      this.Filter.AccountingSeries = null;
    }
    else if(filterType == "DocStatus"){
      this.Filter.DocumentStatus = null;
    }
    else if(filterType == "DocumentNumber"){
      this.Filter.DocumentNumber = null;
    }
    else if(filterType == "Product"){
      this.Filter.Product = null;
    }
    else if(filterType == "Partner"){
      this.Filter.Partner = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }
    else if(filterType == "Country"){
      this.Filter.Country = null;
    }
    else if(filterType == "Currency"){
      this.Filter.Currency = null;
    }
    else if(filterType == "InvoiceDocType"){
      this.Filter.InvoiceDocType = null;
    }
    else if(filterType == "ShippingCompany"){
      this.Filter.ShippingCompany = null;
    }
    else if(filterType == "EFacturaStatus"){
      this.Filter.EFacturaStatus = null;
    }

    this.GetInvoicesFiltered();
}

VizualizeDocument(i:any){
  this.GetInvoice(i, false, true);
}

FillInvoiceInfo(invoice:any){

  this.partner = {};
  this.CurrentInvoice = invoice;
  this.partner = this.CurrentInvoice.Client;

  this.currency = invoice.Currency;

  if(invoice.Products.length > 0){
    this.InvoicePrecision = invoice.Products[0].ProductInvoiceInfo.DecimalPrecision;
  }

  this.Products = invoice.Products;
}

GetInvoice(id:string, UseInvoiceLanguage:boolean, TransferAdvancedPaymentValues:boolean = false){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:id,
    WithInfo:true,
    UseInvoiceLanguage:UseInvoiceLanguage,
    TransferAdvancedPaymentValues:TransferAdvancedPaymentValues
  };

  this.loadingInvoiceID = id;
  this.loadingDocumentInformation = true;

  this.service.GetInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.FillInvoiceInfo(response["Invoice"]);
      this.showInvoiceVisualizer = true;
    }

    this.loadingInvoiceID = null;
    this.loadingDocumentInformation = false;
    this.UseForDocumentSeries = false;
    this.OverWriteForDocumentSeries = false;
  });
}

GetInvoiceDataToGalleryList(id:string, UseInvoiceLanguage:boolean, TransferAdvancedPaymentValues:boolean = false){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:id,
    WithInfo:true,
    UseInvoiceLanguage:UseInvoiceLanguage,
    TransferAdvancedPaymentValues:TransferAdvancedPaymentValues
  };

  this.loadingInvoiceID = id;
  this.loadingDocumentInformation = true;

  this.service.GetInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      for(var i=0;i<this.Invoices.length;i++){
        if(this.Invoices[i].ID == id){
          var inv = response["Invoice"];
          this.Invoices[i].AccountingNumber = inv.AccountingNumber;
          this.Invoices[i].Client = inv.Client;
          this.Invoices[i].Company = inv.Company;
          this.Invoices[i].DocType = inv.DocType;
          this.Invoices[i].GeneralDocType = inv.GeneralDocType;
          this.Invoices[i].PaymentTerm = inv.PaymentTerm;
          this.Invoices[i].Language = inv.Language;
          this.Invoices[i].InitialSavedCurrency = inv.InitialSavedCurrency;
          this.Invoices[i].Currency = inv.Currency;
          this.Invoices[i].MainCurrency = inv.MainCurrency;
          this.Invoices[i].Products = inv.Products;
          this.Invoices[i].CreatingUser = inv.CreatingUser;
          this.Invoices[i].UpdatingUser = inv.UpdatingUser;
          this.Invoices[i].Total = inv.Total;
          this.Invoices[i].TotalAdvance = inv.TotalAdvance;
          this.Invoices[i].DocumentStatus = inv.DocumentStatus;
          this.Invoices[i].PurchaseStatus = inv.PurchaseStatus;
          this.Invoices[i].Administrations = inv.Administrations;
          this.Invoices[i].VATs = inv.VATs;
          this.Invoices[i].Details = inv.Details;

          break;
        }
      }
    }

    this.loadingInvoiceID = null;
    this.loadingDocumentInformation = false;
  });
}

PrintInvoice(i:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
  };

  this.DocumentBodyLoading = true;

  this.service.ExportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.printPage(Document.Name , Document.PDFStream, Document.ID);
    }

    this.DocumentBodyLoading = false;
  });
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

ExportInvoice(i:any, eFileExportType:number = 0){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
    eFileExportType:eFileExportType
  };

  this.DocumentBodyLoading = true;

  this.service.ExportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }

    this.DocumentBodyLoading = false;
  });
}

AutoPrintDocument(i:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
  };

  this.DocumentBodyLoading = true;

  this.service.ExportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.parent.AutoPrintDocument(Document);
    }

    this.DocumentBodyLoading = false;
  });
}

printPage(name:string, html:string, ID:string) {
  var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
  'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
  + ' type="application/pdf"'
  + ' src="data:application/pdf;base64,'
  + escape(html)
  + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

ViewInvoice(i:any){

  if(i.DocumentStatus.ID == -1){
    return;
  }

  const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/dashboard/sales/invoice'], { queryParams: { id: i.ID, user: this.parent.User.Id } }));
  window.open(nextUrl, '_blank');
  // this.router.navigate(['/dashboard/sales/invoice'], { queryParams: { id: i.ID } }); 
}

ShowDeleteInvoiceQuestion:boolean;
ShowDeleteInvoiceRelatedCashCollections:boolean;

DeleteInvoice(invoice:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:invoice.ID,
    DetailsID:invoice.Details.ID,
    AccountingNumber:invoice.AccountingNumber,
    GetAssociatedCashcollections:true
  };

  this.loading = true;

  this.service.DeleteInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
     this.GetInvoicesFiltered();
     this.showInvoiceVisualizer = false;

     this.CashCollections = response["CashCollections"];

     if(this.CashCollections != null && this.CashCollections.length > 0){
      this.ShowDeleteInvoiceRelatedCashCollections = true;
     }
    }

    this.loading = false;
  });

}

ShowDeactivateDocumentQuestion:boolean;
ShowReactivateDocumentQuestion:boolean;

CancelOrActivate(InvoiceID:string,CancelInvoice:boolean){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:InvoiceID,
    CancelInvoice:CancelInvoice,
  };

  this.loading = true;

  this.service.CancelOrActivate(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 1000000);
     this.GetInvoicesFiltered();

     if(this.CurrentInvoice != null && this.CurrentInvoice.ID != null){
      this.GetInvoice(this.CurrentInvoice.ID, true, false);
    }
    }

    this.loading = false;

  });

}

initializePartnerFormFromObject(partner:any){

  this.currentPartner = new FormGroup({

    VAT:new FormControl(partner.VAT),
    UPN:new FormControl(partner.UPN),
    Name:new FormControl(partner.Name, [Validators.required]),
    COCRegNumber:new FormControl(partner.COCRegNumber),

    TaxPayer:new FormControl(partner.TaxPayer),

    Country:new FormControl(partner.BillingAddress.Country),
    StateProvince:new FormControl(partner.BillingAddress.StateProvince, [Validators.required]),
    City:new FormControl(partner.BillingAddress.City, [Validators.required]),
    AddressLine:new FormControl(partner.BillingAddress.AddressLine, [Validators.required]),

    Bank:new FormControl(partner.Bank),
    BankAccount:new FormControl(partner.Bank.BankAccount),

    Email: new FormControl(partner.ContactInfo.Email, [Validators.email]),
    ContactName:new FormControl(partner.ContactInfo.Name),
    Phone:new FormControl(partner.ContactInfo.Phone),
  });
 
  this.showEditPartnerPopUp = true;
  this.partner = partner;
}

UpdatePartner(){
  var request = {
    Partner:{
      ID:String,
      VAT:this.currentPartner.controls['VAT'].value,
      UPN:this.currentPartner.controls['UPN'].value,
      Name:this.currentPartner.controls['Name'].value,
      COCRegNumber:this.currentPartner.controls['COCRegNumber'].value,

      TaxPayer:this.currentPartner.controls['TaxPayer'].value,

      BillingAddress:{
        ID:Number,
        Country:this.currentPartner.controls['Country'].value,
        StateProvince:this.currentPartner.controls['StateProvince'].value,
        City:this.currentPartner.controls['City'].value,
        AddressLine:this.currentPartner.controls['AddressLine'].value,
      },
      Bank:this.currentPartner.controls['Bank'].value,
      ContactInfo:{
        ID:Number,
        Email:this.currentPartner.controls['Email'].value,
        Name:this.currentPartner.controls['ContactName'].value,
        Phone:this.currentPartner.controls['Phone'].value,
      },
      Company:this.parent.Company,
      EUVATVerified:this.partner.EUVATVerified,
    },
    User:this.parent.User,
    Language:this.parent.getLanguage()
  };

  request.Partner.Bank.BankAccount = this.currentPartner.controls['BankAccount'].value;
  request.Partner.ID = this.partner.ID;
  request.Partner.BillingAddress.ID = this.partner.BillingAddress.ID;
  request.Partner.ContactInfo.ID = this.partner.ContactInfo.ID;

  this.parent.loading = true;

  this.service.UpdatePartner(request).subscribe(response => {
 
    if(response["Status"] != 1){
    
    }
    else if(response["Status"] == 1){
     this.showEditPartnerPopUp = false;
     this.parent.openSnackBar("Partner Updated", "OK", "light-info-snackbar");
     this.partner = response["Partner"];
    }
 
    this.parent.loading = false;
  });
}

compareFn(c1: any, c2: any): boolean {
  return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

GenerateNewInvoice(i:any, storno:boolean, newCopy:boolean){
  const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/dashboard/sales/invoice'], { queryParams: { id: i.ID, IsStorno: storno, NewCopy:newCopy } }));
  window.open(nextUrl, '_blank');
  // this.router.navigate(['/dashboard/sales/invoice'], { queryParams: { id: i.ID, IsStorno: storno, NewCopy:newCopy } }); 
}

InitializeNewCashCollection(i:any){

  if(this.Invoices.some(x => x.IsSelected == true)){
    i.IsSelected = true;
  }

  if(this.ProofOriginalCurrencyError() == true){
    return;
  }

  if(this.ProofSinglePartnerSelected() == true){
    return;
  }

  if(i.Currency.ID != i.InitialSavedCurrency.ID && this.Filter.ExchangeToTargetCurrency){
    this.ShowOriginalCurrencyError = true;
    return;
  }

  this.IsCollectiveCollection = false;
  this.CurrentInvoice = i;

  if(!this.Invoices.some(x => x.IsSelected == true)){
    var invoices = [];
    invoices.push(i);
    this.InitializeNewCashCollectionFromServer(invoices);
  }
  else{
    this.InitializeNewCashCollectionFromServer(this.Invoices.filter(x => x.IsSelected == true));
  }

  // this.currentCashCollettion = {};
  // this.currentCashCollettion.Type = this.CashCollectTypes[1];
  // this.currentCashCollettion.Currency = this.CurrentInvoice.Currency;

  // this.CollectionDate = new FormControl(moment());
  // this.currentCashCollettion.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
  // this.CollectionDate = new FormControl(moment(this.currentCashCollettion.CollectionDate));

  // this.currentCashCollettion.BankAccount = {};
  // this.currentCashCollettion.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == this.currentCashCollettion.Currency.ID)[0];

  // this.currentCashCollettion.InvoiceID = i.ID;
  // this.currentCashCollettion.InvoiceDetailsID = i.Details.ID;

  // if(this.CurrentInvoice.Details.CashCollectionRemainingValue >= 0){
  //   this.currentCashCollettion.Value = JSON.parse(JSON.stringify(this.CurrentInvoice.Details.CashCollectionRemainingValue));
  //   this.CollectionRemainingValue = JSON.parse(JSON.stringify(this.CurrentInvoice.Details.CashCollectionRemainingValue));
  // }
}

InitializeNewCollectiveCollection(){
  
  this.ShowDeactivatedDocumentsOnSelectAllQuestion = false;

  if(this.ProofSingleCurrencyOnCollectivePayment() == true){
    return;
  }

  this.IsCollectiveCollection = true;
  this.InitializeNewCashCollectionFromServer(this.Invoices.filter(x => x.IsSelected == true));
  // var i = this.Invoices.filter(x => x.IsSelected == true)[0];
  // this.currentCashCollettion = {};
  // this.currentCashCollettion.Type = this.CashCollectTypes[1];
  // this.currentCashCollettion.Currency = i.Currency;

  // this.CollectionDate = new FormControl(moment());
  // this.currentCashCollettion.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
  // this.CollectionDate = new FormControl(moment(this.currentCashCollettion.CollectionDate));

  // this.currentCashCollettion.BankAccount = {};
  // this.currentCashCollettion.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == this.currentCashCollettion.Currency.ID)[0];

  // this.currentCashCollettion.ReceptionID = i.ID;
  // this.currentCashCollettion.ReceptionDetailsID = i.Details.ID;
  // this.currentCashCollettion.Value = 0;
  // this.CollectionRemainingValue = 0;

  //   this.Invoices.forEach(element => {
  //     if(element.IsSelected){
  //       if(element.Details.CashCollectionRemainingValue > 0){
  //         this.currentCashCollettion.Value = this.currentCashCollettion.Value + JSON.parse(JSON.stringify(element.Details.CashCollectionRemainingValue));
  //         this.CollectionRemainingValue = this.CollectionRemainingValue + JSON.parse(JSON.stringify(element.Details.CashCollectionRemainingValue));
  //       }
  //     }
  //   });
}

InitializeNewCashCollectionFromServer(invoices:any[]){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Invoices:invoices,
    ExchangeToTargetCurrency:this.Filter.ExchangeToTargetCurrency
  };

  this.parent.loading = true;

  this.service.InitializeNewCashCollection(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.currentCashCollettion = response["CashCollection"];
      this.ShowCashCollectionContainer = true; 

      var serverInvoices = response["Invoices"];

      this.Invoices.forEach(inv => {
        for(var i = 0;i<serverInvoices.length;i++){
          if(serverInvoices[i].ID == inv.ID){
            inv.Details = serverInvoices[i].Details;
            break;
          }
        }
      });
    }

    this.parent.loading = false;
  });
}

GetInvoicesCollectionRemainingOrSuprlusValues(){

  var DetailIDs = [];

  this.Invoices.forEach(element => {
    DetailIDs.push(element.Details.ID);
  });

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    DetailIDs:DetailIDs,
    ExchangeToTargetCurrency:this.Filter.ExchangeToTargetCurrency
  };

  this.parent.loading = true;

  this.service.GetInvoicesCollectionRemainingOrSuprlusValues(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      
    }

    this.parent.loading = false;
  });
}

AddCashCollection(){
  
  this.currentCashCollettion.InvoiceDetailsID = this.CurrentInvoice.Details.ID;
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    CashCollect:this.currentCashCollettion,
  };

  if(this.CollectionDate.value != null){
    if(this.CollectionDate.value._d != undefined){
      request.CashCollect.CollectionDate = moment(this.CollectionDate.value._d).format('YYYY-MM-DD');
      this.CollectionDate = new FormControl(moment(this.CollectionDate.value._d).format('YYYY-MM-DD'));
    }
    else{
      request.CashCollect.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
      this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
    }
  }

  this.parent.loading = true;

  this.service.AddCashCollection(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
        this.GetInvoicesFiltered(this.Filter?.Pager?.PageIndex);
        this.GetInvoice(this.CurrentInvoice.ID, false, true);
    }

    this.CollectionDate = new FormControl(moment());
    this.parent.loading = false;
  });
}

AddCollectiveCashCollection(){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    CashCollect:this.currentCashCollettion,
    Invoices:this.Invoices.filter(x => x.IsSelected == true)
  };

  if(this.CollectionDate.value != null){
    if(this.CollectionDate.value._d != undefined){
      request.CashCollect.CollectionDate = moment(this.CollectionDate.value._d).format('YYYY-MM-DD');
      this.CollectionDate = new FormControl(moment(this.CollectionDate.value._d).format('YYYY-MM-DD'));
    }
    else{
      request.CashCollect.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
      this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
    }
  }

  this.parent.loading = true;

  this.service.AddGroupCashCollection(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.GetInvoicesFiltered(this.Filter?.Pager?.PageIndex);
    }

    this.CollectionDate = new FormControl(moment());
    this.parent.loading = false;
  });
}

ExportInvoicesValues(allPages:boolean = false){

  this.Filter.Pager.PageIndex = 1;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter,
      AllPages:allPages
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }
    
    this.parent.loading = true;
    this.showFilter = false;

    this.service.ExportInvoicesValues(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
      }
   
      this.parent.loading = false;
    });
}

GenerateSAGAExport(allPages:boolean = false){

  this.Filter.Pager.PageIndex = 1;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter,
      AllPages:allPages
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }
    
    this.parent.loading = true;
    this.showFilter = false;

    this.service.GenerateSAGAExport(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }
   
      this.parent.loading = false;
    });
}


ReselectBankAccount(c:any){
  this.currentCashCollettion.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == c.ID)[0];
  this.InitializeCCPrecision();
}

InitializeCCPrecision(){
  if((this.currentCashCollettion.Currency?.DecimalPrecision?.ID != 0) == false){
    this.currentCashCollettion.Currency.DecimalPrecision = this.DecimalPrecisions[0];
  }
}

OpenSuggestedCashCollectionModifier(c:any){
  this.currentCashCollettion = c;
  
  if(this.currentCashCollettion.InvoiceDetailsID == null || this.currentCashCollettion.InvoiceDetailsID == undefined){
    this.currentCashCollettion.InvoiceDetailsID = "";
  }

  if(this.currentCashCollettion.InvoiceID == null || this.currentCashCollettion.InvoiceID == undefined){
    this.currentCashCollettion.InvoiceID = "";
  }

  this.CollectionDate = new FormControl(moment(this.currentCashCollettion.CollectionDate));

  if(this.currentCashCollettion.BankAccount == null){
    this.ReselectBankAccount(this.currentCashCollettion.Currency);
  }
}

ShowSuggestedCashCollectionModifier:boolean;

DeleteSuggestedCashCollection(c:any){
  this.CashCollections = this.CashCollections.filter(x => x.UIID != c.UIID);
}

GetInvoiceCashCollections(detailsID:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    DetailsID:detailsID
  };
  
  this.loading = true;

  this.service.GetInvoiceCashCollections(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CashCollections = response["CashCollections"];
      this.CashTotals = response["Totals"];
      this.ShowSuggestionCashCollectionsContainer = true;
    }
 
    this.loading = false;
  });

  this.GetInvoicesFilteredCOUNT();
}

CCInvoices:any[];
ShowDeleteSpendingQuestion:boolean;

SearchInvoices(s:string){

  if(s.length > 2){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:s,
      WithPartnerInfo:true
    };

    this.service.SearchInvoices(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CCInvoices = response["Invoices"];
      }
   
      this.parent.loading = false;
    });
  }
}

DeallocateInvoiceFromCC(){
  this.currentCashCollettion.Status = this.DocumentStatuses.find(x => x.ID == -1);
}

SelectInvoiceForCashCollectionSearch(i:any){
  this.currentCashCollettion.InvoiceID = i.ID;
  this.currentCashCollettion.InvoiceDetailsID = i.Details.ID;
  this.currentCashCollettion.DisplayValue = i.AccountingNumber.DisplayValue;
  this.currentCashCollettion.Client = i.Client;

  this.currentCashCollettion.Status = this.DocumentStatuses.find(x => x.ID == 1);
  this.Invoices = null;
}

DeleteCashCollections(ccs:any[]){
  ccs.forEach(cc => {
    this.DeleteCashCollection(cc.ID);
  });
}

DeleteCashCollection(ID:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:ID,
  };

  this.parent.loading = true;

  this.service.DeleteCashCollection(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CashCollections = this.CashCollections.filter(x => x.ID != ID);
      this.ShowDeleteSpendingQuestion = false;
      this.currentCashCollettion = null;

      if(this.CashCollections.length == 0){
        this.ShowSuggestionCashCollectionsContainer = false;
      }

      this.GetInvoicesFiltered();
    }

    this.parent.loading = false;
  });
}

CloneCashCollection(c:any){
  this.currentCashCollettion = JSON.parse(JSON.stringify(c));
  this.CollectionDate = new FormControl(moment(this.currentCashCollettion.CollectionDate));

  if(this.currentCashCollettion.BankAccount == null){
    this.ReselectBankAccount(this.currentCashCollettion.Currency);
  }
}

UpdateCashCollection(c:any){

  if(this.CollectionDate.value._d != undefined){
    c.CollectionDate = moment(this.CollectionDate.value._d).format('YYYY-MM-DD');
  }

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    CashCollect:c,
  };
  
    this.parent.loading = true;

    this.service.UpdateCashCollection(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
          this.GetInvoicesFiltered(this.Filter?.Pager?.PageIndex);
      }
  
      this.CollectionDate = new FormControl(moment());
      this.ShowSuggestionCashCollectionsContainer = false;
      this.parent.loading = false;
    });
}

ShowProformaInvoiceConvertorQuestion = false;
ShowAdvancePaymentInvoiceToFinancialInvoiceQuestion = false;

ConvertProformaToInvoiceQuestion(i:any){
  this.CurrentInvoice = i;
  this.ShowProformaInvoiceConvertorQuestion = true;
}

ConvertAdvancePaymentInvoiceToFinancialInvoiceQuestion(i:any){
  this.CurrentInvoice = i;
  this.ShowAdvancePaymentInvoiceToFinancialInvoiceQuestion = true;
}

ConvertProformaToInvoice(id:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:id
  };
  
  this.parent.loading = true;
  this.showFilter = false;

  this.service.ConvertProformaToInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.showInvoiceVisualizer = false;
      this.ShowProformaInvoiceConvertorQuestion = false;
      this.GetInvoicesFiltered();
    }
 
    this.parent.loading = false;
  });
}

ConvertAdvancePaymentInvoiceToFinancialInvoice(id:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:id
  };
  
  this.parent.loading = true;
  this.showFilter = false;

  this.service.ConvertAdvancePaymentInvoiceToFinancialInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.showInvoiceVisualizer = false;
      this.ShowAdvancePaymentInvoiceToFinancialInvoiceQuestion = false;
      this.GetInvoicesFiltered();
    }
 
    this.parent.loading = false;
  });
}

SelectAll(){
  this.Invoices.forEach(r => {
    r.IsSelected = this.AllSelected;
  });

  this.CheckIfAnyChecked();
}

ShowDeactivatedDocumentsOnSelectAllQuestion:boolean;
SingleCurrencyOnCollectivePaymentError:boolean;
ShowOriginalCurrencyError:boolean;

ProofSingleCurrencyOnCollectivePayment() : boolean {
  this.SingleCurrencyOnCollectivePaymentError = false;
  var currencies = [];

  this.Invoices.forEach(i => {
    if(i.IsSelected == true){
      if(!currencies.find(x => x == i.Currency?.ID) && i.Currency != null){
        currencies.push(i.Currency?.ID);
      }        
    }
  });

  if(currencies.length > 1){
    this.SingleCurrencyOnCollectivePaymentError = true;
  }

  return this.SingleCurrencyOnCollectivePaymentError;
}

AlertDeactivatedDocumentsOnSelectAll(r:any){
  
  if(this.ProofOriginalCurrencyError() == true){
    return;
  }

  if(this.ProofSinglePartnerSelected() == true){
    return;
  }

  this.Invoices.find(x => x.ID == r.ID).IsSelected = true;
  var exists = false;
  
  this.Invoices.forEach(i => {
    if(i.DocumentStatus.ID == -1 && i.IsSelected == true){
      exists = true;
    }
  });

  if(exists){
    this.ShowDeactivatedDocumentsOnSelectAllQuestion = true;
  }
  else{
    this.InitializeNewCollectiveCollection();
  }
}

DeselectDeactivatedDocs(){
  this.Invoices.forEach(i => {
    if(i.DocumentStatus.ID == -1 && i.IsSelected == true){
      i.IsSelected = false;
    }
  });
}

ShowMustSelectSinglePartnerError:boolean;

ProofSinglePartnerSelected() : boolean {
  this.ShowMustSelectSinglePartnerError = false;

  var samePartner = this.Invoices.filter(x => x.IsSelected == true).every( a => a.Client.ID === this.Invoices.filter(x => x.IsSelected == true)[0].Client.ID);

  if(!samePartner){
    this.ShowMustSelectSinglePartnerError = true;
  }

  return this.ShowMustSelectSinglePartnerError;
}

ProofOriginalCurrencyError() : boolean {

  this.ShowOriginalCurrencyError = false;

  if(this.Filter.ExchangeToTargetCurrency){

    this.Invoices.forEach(i => {
      if(i.IsSelected == true && i.Currency.ID != i.InitialSavedCurrency.ID){
        this.ShowOriginalCurrencyError = true;
      }
    });
  }

  return this.ShowOriginalCurrencyError;
}

VerifyPriceModel(p:string){
  var result = this.parent.NormalizePrice(p);

  if(this.currentCashCollettion != null){
    this.currentCashCollettion.Value = result;
  }
}

GenerateReceptionFromInvoice(i:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID
  };
  
  this.parent.loading = true;
  this.showFilter = false;

  this.service.GenerateReceptionFromInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
 
    this.parent.loading = false;
  });
}

ShuffleElements(increment:number, invoice:any){

   var index = 0;

   for(var i= 0;i < this.Invoices.length; i++){
      if(this.Invoices[i].ID == invoice.ID){
        break;
      }
      else{
        index++;
      }
   }

   if(increment < 0){
      if(this.Invoices.length - 1 > index){
        this.showInvoiceVisualizer = false;
        this.VizualizeDocument(this.Invoices[index + 1].ID);
      }
   }
   else{
      if(index > 0){
        this.showInvoiceVisualizer = false;
        this.VizualizeDocument(this.Invoices[index - 1].ID);
      }
   }

}

SellThroughPartnerSelectSellingPartner:boolean;
SellThroughPartnerSelectSellingPartnerPart2:boolean;
SellThroughPartnerSelectSellingPartnerPart3:boolean;

SellingPartners:any[];
SellingPartner:any;
loadingInvoicePurchasePrices:boolean;
ProductsPurchasePricesToBeCompleted:number;

OpenSellThroughPartnerSelectSellingPartner(i:any){
  this.SellingPartners = [];
  this.SellingPartner = undefined;
  this.CurrentInvoice = i;
  this.GetCompanySubordonates();
}

GetCompanySubordonates(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };
  
  this.parent.loading = true;
  this.showFilter = false;

  this.service.GetCompanySubordonates(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SellingPartners = response["Subordonates"];

      if(this.SellingPartners != null && this.SellingPartners != undefined && this.SellingPartners.length > 0){
        this.SellingPartner = this.SellingPartners[0];
      }

      this.SellThroughPartnerSelectSellingPartner = true;
    }
 
    this.parent.loading = false;
  });
}

GetInvoicePurchasePrices(i:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
    AllMustBeComplete:true
  };
  
  this.ProductsPurchasePricesToBeCompleted = 0;
  this.loadingInvoicePurchasePrices = true;

  this.service.GetInvoicePurchasePrices(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentInvoice = response["Invoice"];
      this.SellThroughPartnerSelectSellingPartner = false;
      this.SellThroughPartnerSelectSellingPartnerPart2 = true;

      this.CurrentInvoice.Products.forEach(p => {
        if(p.ProductInvoiceInfo.PurchaseInfo?.Status?.ID == 0){
          this.ProductsPurchasePricesToBeCompleted++;
        }
      });

      this.PreparePurchasePriceCurrencyAndVATAdjustmentBetweenSubordonates();
    }
  });
}

PreparePurchasePriceCurrencyAndVATAdjustmentBetweenSubordonates(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Products:this.CurrentInvoice.Products,
    SellingPartner:this.SellingPartner,
    InitialInvoiceCurrency:this.CurrentInvoice.Currency
  };

  this.loadingInvoicePurchasePrices = true;

  this.service.PreparePurchasePriceCurrencyAndVATAdjustmentBetweenSubordonates(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentInvoice.Currency = response["InitialInvoiceCurrency"];
      this.CurrentInvoice.Products = response["Products"];
    }
 
    this.loadingInvoicePurchasePrices = false;
  });
}

GetPriceInformation(p:any){

  var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Price:p.ProductInvoiceInfo.Price,
      Precision:this.InvoicePrecision.ID,
      HasVAT:p.ProductInvoiceInfo.PriceContainsVAT,
      Quantity:p.ProductInvoiceInfo.Quantity,
      IsStorno:false,
      Discount:null,
      AdvancePaymentPercentage:null
    };

    this.loadingInvoicePurchasePrices = true;

    this.service.GetPriceInformation(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
         
        this.CurrentInvoice.Products.forEach(product => {
          if(product.ProductInvoiceInfo.ID == p.ProductInvoiceInfo.ID){
            product.ProductInvoiceInfo.Price = response["Price"];
          }
        });

      this.loadingInvoicePurchasePrices = false;
      }
    });
  }

  ProofSellThroughPartnerStepTwo(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CurrentInvoice:this.CurrentInvoice
    };
  
    this.loadingInvoicePurchasePrices = true;
  
    this.service.ProofSellThroughPartnerStepTwo(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 20000);
        this.PrepareSellThroughPartnerTransferInvoices();
      }
   
      this.loadingInvoicePurchasePrices = false;
    });
  }

  SellThroughPartnerFinalClientInvoice:any;
  SellThroughPartnerPartnerInvoice:any;

  PrepareSellThroughPartnerTransferInvoices(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CurrentInvoice:this.CurrentInvoice,
      SellingPartner:this.SellingPartner
    };
  
    this.loadingInvoicePurchasePrices = true;
  
    this.service.PrepareSellThroughPartnerTransferInvoices(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SellThroughPartnerFinalClientInvoice = response["FinalClientInvoice"];
        this.SellThroughPartnerPartnerInvoice = response["PartnerInvoice"];
        this.SellThroughPartnerSelectSellingPartnerPart2 = false;
        this.SellThroughPartnerSelectSellingPartnerPart3 = true;
      }
   
      this.loadingInvoicePurchasePrices = false;
    });
  }

  SellThroughPartner(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerInvoice:this.SellThroughPartnerPartnerInvoice,
      FinalClientInvoice:this.SellThroughPartnerFinalClientInvoice
    };
  
    this.loadingInvoicePurchasePrices = true;
  
    this.service.SellThroughPartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.SellThroughPartnerSelectSellingPartnerPart3 = false;
       this.GetInvoicesFiltered();
      }
   
      this.loadingInvoicePurchasePrices = false;
    });
  }

  AnyChecked:boolean;

  CheckIfAnyChecked(){
    this.AnyChecked = false;

    this.Invoices.forEach(element => {
      if(element.IsSelected){
        this.AnyChecked = true;
      }
    });
  }

  AutoPrintInvoices(){

    var ids = [];
  
    this.Invoices.forEach(element => {
      if(element.IsSelected){
        ids.push(element.ID);
      }
    });

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoicesIDs:ids,
    };
  
    this.parent.loading = true;
    this.ShowAutoPrintBulkQuestion = false;
  
    this.service.AutoPrintInvoices(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
  
      this.parent.loading = false;
    });
  }

  ShowAutoPrintBulkQuestion:boolean;

  JuggleSorting(){
    for(var i=0;i<this.SortingOrders.length;i++){

      if(this.SortingOrders[i].ID == this.Filter.SortingOrder.ID){
        if(i < this.SortingOrders.length - 1){
          this.Filter.SortingOrder = this.SortingOrders[i + 1];
          break;
        }
        else{
          this.Filter.SortingOrder = this.SortingOrders[0];
        }
      }
    }

    this.GetInvoicesFiltered(this.Filter.Pager.PageIndex);
  }

  ShowShippingDetailsContainer:boolean;

  GetShippingDetails(DetailsID:number, PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ParentDetailsID:DetailsID,
      ShippingMasterData:this.ShippingMasterData,
      PartnerID:PartnerID,
      GetStatistics:true,
    };
  
    this.parent.loading = true;
  
    this.service.GetInvoiceShippingDetails(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
        this.ShowShippingDetailsContainer = true;
      }
      else if(response["Status"] == 0){
        this.parent.openSnackBar(response["Message"], "OK", "warning-info-snackbar");
        this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
        this.ShowShippingDetailsContainer = true;
      }
  
      this.parent.loading = false;
    });
  }
  
  AddNewBox(ShippingDetailsID:number){
    var box = {
      ID:0,
      ParentShippingDetailsID:ShippingDetailsID,
      Length:10,
      Width:10,
      Height:10,
      Weight:1,
      TrackingLabel:null,
      IsPallet:false,
      UIID:this.parent.newGuid(),
    };
  
    this.CurrentInvoice.Details.ShippingDetails.Boxes.push(box);
  }
  
  ProofShippingDetails(ShippingDetails:number, SaveToDB:boolean = false){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:ShippingDetails,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.ProofShippingDetails(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowShippingDetailsContainer = false;
  
        if(SaveToDB == true){
  
          if(this.CurrentInvoice.Details.ShippingDetails.ID > 0){
            this.UpdateShippingDetails(this.CurrentInvoice.Details.ShippingDetails);
          }
          else{
            this.AddShippingDetails(this.CurrentInvoice.Details.ShippingDetails);
          }
        }
      }

      this.DocumentBodyLoading = false;
    });
  }
  
  ShowDeleteBoxQuestion:boolean;
  CurrentBox:any;
  
  DeleteBox(box:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      BoxID:box.ID
    };
  
    this.parent.loading = true;
  
    this.service.DeleteInvoiceBox(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.Details.ShippingDetails.Boxes = this.CurrentInvoice.Details.ShippingDetails.Boxes.filter(item => item.UIID != box.UIID);
      }
  
      this.parent.loading = false;
    });
  }
  
  AddShippingDetails(ShippingDetails:any){
    
    ShippingDetails.Partner = this.CurrentInvoice.Client;
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:ShippingDetails,
    };
  
    this.parent.loading = true;
  
    this.service.AddShippingDetails(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
      }
  
      this.parent.loading = false;
    });
  }
  
  UpdateShippingDetails(ShippingDetails:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:ShippingDetails,
    };
  
    this.parent.loading = true;
  
    this.service.UpdateShippingDetails(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
      }
  
      this.parent.loading = false;
    });
  } 

  ShowDeleteShippingDetailsContainer:boolean;

  DeleteShippingDetails(ShippingDetails:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:ShippingDetails,
    };
  
    this.parent.loading = true;
  
    this.service.DeleteShippingDetails(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
        this.ShowShippingDetailsContainer = false;
        this.parent.openSnackBar(response["Message"], "OK", "info-info-snackbar");
      }
  
      this.parent.loading = false;
    });
  } 

  GenerateInvoicesDeliveryNote(i:any){
    
    if(this.ProofSinglePartnerSelected() == true){
      return;
    }

    var invoices = this.Invoices.filter(x => x.IsSelected == true);

    if(i.IsSelected != true){
      invoices.push(i);
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Invoices:invoices
    };
  
    this.parent.loading = true;
  
    this.service.GenerateInvoicesDeliveryNote(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }
  
      this.parent.loading = false;
    });
  }

  ShowExportBulkQuestion:boolean;

  AutoExportInvoices(){

    this.parent.loading = true;

    this.Invoices.forEach(i => {
      
      if(i.IsSelected == true){
        this.ExportInvoice(i);
      }
    });

    this.parent.loading = false;
  }

  ShowObservationDetailContainer:boolean;

  UpdateInvoiceObservations(DetailsID:number, Observations:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DetailsID:DetailsID,
      Observations:Observations
    };
  
    this.parent.loading = true;
  
    this.service.UpdateInvoiceObservations(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowObservationDetailContainer = false;
      }
  
      this.parent.loading = false;
    });
  } 

  InitializeEmailBulkSendContainer(){

    var invoices = [];
    this.Invoices.forEach(i => {
      if(i.IsSelected){
        invoices.push(i);
      }
    });

    if(invoices.length == 0){
      invoices.push(this.CurrentInvoice);
    }

    this.parent.InitializeEmailBulkSendContainer(this.CurrentInvoice.Client, this.CurrentInvoice.GeneralDocType, invoices);
  }

  ForceDocumentClosing(i:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DocumentID:i.ID,
      ForceDocumentClosing:!i.Details.ForceDocumentClosing
    };
  
    this.parent.loading = true;
  
    this.service.ForceInvoiceDocumentClosing(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowForceStatusContainer = false;
        this.CurrentInvoice.Details.ForceDocumentClosing = !this.CurrentInvoice.Details.ForceDocumentClosing;
        this.CurrentInvoice.DocumentStatus = response["DocumentStatus"];
      }
  
      this.parent.loading = false;
    });
  } 

  ShowSellthroughPartnerProfitsRecallibration : boolean = false;
  loadingProfitsRecallibration:boolean = false;
  SalesDocumentsTraces:any[] = [];
  ProfitInitial:number;
  ShowRecallibrateProfitsSTPFinal:boolean;

  GetSalesDocumentsTraces(i:any){

    if(this.Invoices.some(x => x.IsSelected == true)){
      i.IsSelected = true;
    }

    var FinalClientInvoicesIDs = [];

    this.Invoices
    .forEach(element => {
      if(element.IsSelected == true){
        FinalClientInvoicesIDs.push(element.ID);
      }
    });

    if(FinalClientInvoicesIDs.length == 0){
      FinalClientInvoicesIDs.push(i.ID);
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      FinalClientInvoicesIDs:FinalClientInvoicesIDs
    };
  
    this.parent.loading = true;
  
    this.service.GetSalesDocumentsTraces(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.SalesDocumentsTraces = [];
      }
      else if(response["Status"] == 1){
        this.ShowSellthroughPartnerProfitsRecallibration = true;
        this.SalesDocumentsTraces = response["SalesDocumentsTraces"];

        if(this.SalesDocumentsTraces != null && this.SalesDocumentsTraces.length > 0){
          this.ProfitInitial = this.SalesDocumentsTraces[0].ProfitInitial;
        }
      }
  
      this.parent.loading = false;
    });
  } 

  CloseSellthroughPartnerProfitsRecallibration(){
    this.ShowSellthroughPartnerProfitsRecallibration = false;
    this.SalesDocumentsTraces = [];
  }

  RecallibrateProfitsSTP(){

    this.SalesDocumentsTraces.forEach(trace => {
      trace.ProfitInitial = JSON.parse(JSON.stringify(this.ProfitInitial));
      trace.ProfitFinal = 100 - trace.ProfitInitial;
    });

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SalesDocumentsTraces:this.SalesDocumentsTraces
    };
  
    this.parent.loading = true;
  
    this.service.RecallibrateProfitsSTP(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
  
      this.parent.loading = false;
    });
  }

  autoTicks = false;
  showTicks = false;
  tickInterval = 1;

  getSliderTickInterval(): number | 'auto' {
    if (this.showTicks) {
      return this.autoTicks ? 'auto' : this.tickInterval;
    }

    return 0;
  }

  UseForDocumentSeries:boolean;
  OverWriteForDocumentSeries:boolean;
  SeriesModelSettings:any;

  OpenInvoiceModelSettings(){
    if(this.CurrentInvoice.ModelSettings.ShowInvoiceSettings == false){
      this.GetAccountingSeriesModelSettings();
    }
    else{
      this.CurrentInvoice.ModelSettings.ShowInvoiceSettings = false;
    }
  }

  GetAccountingSeriesModelSettings(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SeriesID:this.CurrentInvoice.AccountingNumber.AccountingSeries.ID
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.GetAccountingSeriesModelSettings(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SeriesModelSettings = response["ModelSettings"];
      }
  
      this.CurrentInvoice.ModelSettings.ShowInvoiceSettings = true;
      this.DocumentBodyLoading = false;
    });
  }

  AddUpdateInvoiceModelSettings(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ModelSettings:this.CurrentInvoice.ModelSettings,
      UseForDocumentSeries:this.UseForDocumentSeries,
      OverWriteForDocumentSeries:this.OverWriteForDocumentSeries,
      AccountingSeries:this.CurrentInvoice.AccountingNumber.AccountingSeries
    };
  
    this.parent.loading = true;
  
    this.service.AddUpdateInvoiceModelSettings(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.ModelSettings = response["ModelSettings"];
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
  
      this.parent.loading = false;
    });
  }

  GetEFacturaXML(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
      UseInvoiceLanguage:false,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.GetEFacturaXML(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }
  
      this.DocumentBodyLoading = false;
    });
  }

  GetEFacturaState(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.GetEFacturaState(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.Details.EFacturaDetails = response["EFacturaDetails"];

        this.Invoices.forEach(element => {
          if(element.ID == this.CurrentInvoice.ID){
            element.Details = this.CurrentInvoice.Details;
          }
        });
      }
  
      this.showInvoiceVisualizer = false;
      this.DocumentBodyLoading = false;
    });
  }

  GetEFacturaFiles(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
      InvoiceDetailsID:i.Details.ID,
      FileType:1,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.GetEFacturaFiles(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.GetEFacturaState(i);        
      }
      else if(response["Status"] == 1){
        if(request.FileType == 1){
          var PDF = response["PDF"];
          this.download(PDF.Name, PDF.PDFStream);
        }
        else if(request.FileType == 2){
          var XML = response["XML"];
          this.download(XML.Name, XML.PDFStream);
        }
        else if(request.FileType == 0){

          var PDF = response["PDF"];
          this.download(PDF.Name, PDF.PDFStream);

          var XML = response["XML"];
          this.download(XML.Name, XML.PDFStream);
        }
      }
  
      this.DocumentBodyLoading = false;
    });
  }

  UploadEFacturaBulk(){
    this.Invoices.forEach(element => {
      if(element.IsSelected){
        this.UploadEFactura(element);
      }
    });
  }

  ShowEFacturaQuestion:boolean = false;

  UploadEFactura(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
      InvoiceDetailsID:i.Details.ID,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.UploadEFactura(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        i.Details.EFacturaDetails = response["EFacturaDetails"];

        this.Invoices.forEach(element => {
          if(element.ID == i.ID){
            element.Details = i.Details;
          }
        });
      }
  
      this.ShowEFacturaBulkQuestion = false;
      this.ShowEFacturaQuestion = false;
      this.showInvoiceVisualizer = false;
      this.DocumentBodyLoading = false;
    });
  }

  EFacturaInvoices:any[];
  ShowEFacturaSendMenu:boolean = false;
  ShowEFacturaBulkQuestion:boolean = false;

  OpenEFacturaAPIMenuSingleInvoice(invoice:any){
    this.EFacturaInvoices = [];
    this.EFacturaInvoices.push(invoice);
    this.ShowEFacturaSendMenu = true;
    this.showInvoiceVisualizer = false;
  }

  OpenEFacturaAPIMenu(invoices:any[]){
    this.EFacturaInvoices = [];
    this.EFacturaInvoices.push(invoices);
    this.ShowEFacturaSendMenu = true;
    this.showInvoiceVisualizer = false;
  }


TrackInvoice(i:any){

  if(i.Details?.ShippingDetails?.TrackingLabel?.length > 0){
    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/management/track/shipment'], { queryParams: { Courier: i.Details.ShippingDetails.ShippingCompany.Name, Tracking: i.Details.ShippingDetails.TrackingLabel } }));
    window.open(nextUrl, '_blank');
  }
}

ShowCombineInOneInvoiceQuestion:boolean = false;
CombineInOneInvoiceSecurityPIN:string = "";
hide = true;

MergeInvoices(){

  var invoices = this.Invoices.filter(x => x.IsSelected);

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Invoices:invoices,
    SecurityPIN:this.CombineInOneInvoiceSecurityPIN
  };

  this.parent.loading = true;

  this.service.MergeInvoices(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShowCombineInOneInvoiceQuestion = false;
      this.GetInvoicesFiltered();
    }

    this.parent.loading = false;
  });
}

EFacturaGeneralData:any;
ShowANAFRedirectionNotification:boolean = false;

GetCompanyEFacturaGeneralData(){
 
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    CompanyID:this.parent.Company?.ID
  };

  this.parent.loading = true;

  this.service.GetCompanyEFacturaGeneralData(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.EFacturaGeneralData = response["EFacturaGeneralData"];

      if(this.EFacturaGeneralData.ValidToken != true){
        this.parent.loading = true;
        setTimeout(() => { // Introducing a 2-second timeout
          this.PrepareCompanyEFacturaAwaitingToken();
        }, 2000); // 2000 milliseconds = 2 seconds
      }
      else{
        this.Invoices.forEach(element => {
          if(element.IsSelected == true){
            this.UploadEFactura(element);
          }
        });
      }
    }

    this.ShowEFacturaBulkQuestion = false; 
    this.parent.loading = false;
  });
}

PrepareCompanyEFacturaAwaitingToken(){
 
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };

  this.parent.loading = true;

  this.service.PrepareCompanyEFacturaAwaitingToken(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      this.ShowANAFRedirectionNotification = true;
    }

    this.ShowEFacturaBulkQuestion = false; 
    this.parent.loading = false;
 
  });
}

ShowResetEFactura:boolean = false;

OpenResetEFactura(i:any){
  this.CurrentInvoice = JSON.parse(JSON.stringify(i));
  this.ShowResetEFactura = true;
}

ResetEFacturaStatus(i:any){
 
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
  };

  this.parent.loading = true;

  this.service.ResetEFacturaStatus(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");

      i.Details.EFacturaDetails = response["EFacturaDetails"];

      this.Invoices.forEach(element => {
        if(element.ID == i.ID){
          element.Details = i.Details;
        }
      });
    }

    this.ShowResetEFactura = false; 
    this.parent.loading = false;
 
  });
}

UpdateDocumentTransportationCost(i:any){
 
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    DocumentID:i.ID,
    GeneralDocType:2,
  };

  this.parent.loading = true;

  this.service.UpdateDocumentTransportationCost(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      
    }

    this.parent.loading = false;
  });
}

ShowPreAskClientBalanceAllocation:boolean = false;

PreAskClientBalanceAllocation(){
  this.ShowPreAskClientBalanceAllocation = true;
}

AutoAllocateClientBalance(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Partner:this.Filter.Partner
  };
  this.parent.loading = true;

  this.service.AutoAllocateClientBalance(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.GetInvoicesFiltered(this.Filter.Pager.PageIndex);
    }

    this.ShowPreAskClientBalanceAllocation = false;
    this.parent.loading = false;
  });
}

GetShippingMasterData(WithROETransportData:boolean = false){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    WithROETransportData:WithROETransportData,
  };

  this.service.GetShippingMasterData(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShippingWays = response["ShippingWays"];
      this.ShippingServiceTypes = response["ShippingServiceTypes"];
      this.ShippingResponsabilities = response["ShippingResponsabilities"];
      this.ShippingCompanies = response["ShippingCompanies"];
      this.WeightTypes = response["WeightTypes"];

      this.ShippingMasterData = response;

      if(WithROETransportData == true){
        this.CustomsStations = JSON.parse(JSON.stringify(this.ShippingMasterData.CustomsStations));
        this.ETransportDocumentTypes = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportDocumentTypes));
        this.ETransportMeasuringUnits = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportMeasuringUnits));
        this.ETransportOperationReasons = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportOperationReasons));
        this.ETransportOperationTypes = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportOperationTypes));
        this.ETransportCustomsBureaus = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportCustomsBureaus));
      }
    }
  });
}

CustomsStations:any[];
ETransportDocumentTypes:any[];
ETransportMeasuringUnits:any[];
ETransportOperationReasons:any[];
ETransportOperationTypes:any[];
ETransportCustomsBureaus:any[];

ETransportCustomsStation:any;
ETransportDocumentType:any;
ETransportMeasuringUnit:any;
ETransportOperationReason:any;
ETransportOperationType:any;
UITShippingCompany:any;
UITAutoPlatesNumber:string;
ETransportCustomsBureau:any;

ShowETransportStepOne:boolean = false;

PrepareGenerateUITDataUX(Partner:any, GeneralDocType:number){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Partner:Partner,
    GeneralDocType:GeneralDocType
  };

  this.DocumentBodyLoading = true;

  this.service.PrepareGenerateUITDataUX(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ETransportCustomsStation = response["CustomsStation"];
      this.ETransportDocumentType = response["ETransportDocumentType"];
      this.ETransportMeasuringUnit = response["ETransportMeasuringUnit"];
      this.ETransportOperationReason = response["ETransportOperationReason"];
      this.ETransportOperationType = response["ETransportOperationType"];
      this.UITShippingCompany = response["ShippingCompany"];
      this.UITAutoPlatesNumber = response["AutoPlatesNumber"];
      this.ETransportCustomsBureau = response["ETransportCustomsBureau"];

      this.ShowETransportStepOne = true;
    }

    this.DocumentBodyLoading = false;
  });
}

UploadETransportInvoice(i:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Document:i,
    AutoPlatesNumber:this.UITAutoPlatesNumber,
    CustomsStation:this.ETransportCustomsStation,
    ETransportDocumentType:this.ETransportDocumentType,
    ETransportMeasuringUnit:this.ETransportMeasuringUnit,
    ETransportOperationReason:this.ETransportOperationReason,
    ETransportOperationType:this.ETransportOperationType,
    ETransportCustomsBureau:this.ETransportCustomsBureau,
    ShippingCompany:this.UITShippingCompany,
  };

  this.DocumentBodyLoading = true;

  this.service.UploadETransportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      
    }

    this.DocumentBodyLoading = false;
  });
}

PrepareETransportStep1(){
  this.GetShippingMasterData(true);
  this.PrepareGenerateUITDataUX(this.CurrentInvoice?.Client, 2);
}

}
